import styled from 'styled-components/macro';

export const ScWrapper = styled.div<{ fullWidth?: boolean, isSmall?: boolean }>`
  box-sizing: border-box;
  max-width: ${props => !props.fullWidth && '1200px'};
  padding: ${props => props.fullWidth ? '0 16px' : 0};
  padding: ${props => props.isSmall && 0};
  margin: 0 auto;
`;
